<template>
  <div>
        <h4 class="mb-4"><v-icon right>mdi-file-document-edit-outline</v-icon> Resumen de totales</h4>
        <table class="text-xs bg-white border-collapse mb-4">
          <tr>
             <th class="text-left px-2 py-2">
                    Fecha del pedido
                  </th>
                   <td class="border-b px-2 py-2">{{ dateOrder | moment("DD/MM/YYYY") }}</td>
          </tr>
                <tr>
                  <th class="text-left px-2 py-2">
                    {{ this.$store.state.Auth.user.role }}
                  </th>
                   <td class="border-b px-2 py-2">{{ this.$store.state.Auth.user.name }}</td>
                </tr>
            <tr>
               <th class="text-left px-2 py-2">
                    Nombre Comunidad
                  </th>
              <td class="border-b px-2 py-2">{{ comunidadName }}</td>
            </tr>
         </table>
         <table class="w-full text-xs bg-white border-collapse">
              <thead>
                <tr>
                  <th class="border text-left px-2 py-2">
                    Cilindros 
                    
                  </th>
                  <th class="border text-left px-2 py-2">
                    Cantidad 
                    
                  </th>
                  <th class="border text-left px-2 py-2">
                    Dias de Bloqueo
                  </th>
                </tr>
              </thead>
          <tbody>
            <tr v-for="cilindroPesosCantidad in detail.cilindros" :key="cilindroPesosCantidad.peso">
              <td class="border px-2 py-2">Cilindro de {{ cilindroPesosCantidad.peso }}</td>
              <td class="border px-2 py-2 text-right">{{ cilindroPesosCantidad.total }}</td>
              <td class="border px-2 py-2 text-right">{{ diasBloqueos(cilindroPesosCantidad.peso) }}</td>
            </tr>
            <tr class="bg-orange">
              <td class="border font-bold py-2 px-2">Totales</td>
              <td class="border py-2 px-2 text-right">---</td>
              <td class="border py-2 px-2 text-right">---</td>
            </tr>
            <tr>
              <td class="px-2 py-2"></td>
            </tr>
            <tr>
              <td class="bg-gray-700 text-white font-bold border px-2 py-2">SubTotal</td>
              <td class="font-bold border px-2 py-2">Impuestos</td>
              <td class="border bg-gray-700 text-white font-bold px-2 py-2 text-right">{{ formatCurrency(totalPagar) }} Bs.</td>
            </tr>
            <tr>
              <td class="border px-2 py-2">% IVA</td>
              <td class="border px-2 py-2 text-right"><span>%</span> 0</td>
              <td class="border px-2 py-2 text-right">0.00 Bs.</td>
            </tr>
            <tr>
              <td class="border px-2 py-2">Total a pagar</td>
              <td class="border px-2 py-2"></td>
              <td class="border px-2 py-2 text-right font-bold text-green">{{ formatCurrency(totalPagar) }} Bs.</td>
            </tr>
          </tbody>
         </table>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex"
import messageMixin from "@/mixins/common"

export default {
  name: "resumen-totales-pedidos",
  mixins: [messageMixin],
  props: {
    jefeComunidadName: {
      type: String,
      default: null,
    },
    comunidadName: {
      type: String,
      default: null,
    },
    totalCilindros: {
      type: Number,
      default: 0,
    },
    totalPagar: {
      type: Number,
      default: 0,
    },
    dateOrder: {
      type: Date,
    },
  },
  data() {
    return {
      cilindrosPesosCantidad: [],
    }
  },
  computed: {
    ...mapGetters("Auth", ["comunidad"]),
    ...mapState("Pedidos", ["detail"]),
  },

  methods: {
    ...mapMutations("Pedidos", ["setDetail"]),
    diasBloqueos(kg) {
      if (kg === '10 KG') { return 15;}
      if (kg === '18 KG') { return 30;}
      if (kg === '27 KG') { return 50;}
      if (kg === '43 KG') { return 80;}
      return 1;
    },
  },
}
</script>
<style>
 .section {
    display: flex;
    flex-wrap: wrap;
    margin-top: 1rem;
  }
 .article-full {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  width: 100%;
}
.text-xs {
  font-size: .75rem;
  line-height: 1rem;
}
.border-collapse {
  border-collapse: collapse;
}
table {
  border-collapse: collapse;
  border-color: inherit;
  text-indent: 0;
}
.text-left {
  text-align: left;
}
.text-right {
  text-align: right;
}
.border {
  border: 1px solid rgb(229 231 235);
}
.border-b {
  border-bottom: 1px solid rgb(229 231 235);
}
.w-full {
  width: 100%;
}
.font-bold {
  font-weight: 700;
}
thead {
  display: table-header-group;
  vertical-align: middle;
}
th {
    display: table-cell;
    vertical-align: inherit;
    font-weight: bold;
    text-align: -internal-center;
}
.text-white {
  color: #FFFFFF;
}
.bg-gray-700 {
  background-color: #384152;
}
.bg-orange {
  background-color: #fed8ab;
}
</style>
